import { FC } from 'react';

import RadioGroup, { RadioGroupProps } from 'components/RadioGroup';

type Props = Omit<RadioGroupProps, 'options'>;

const options = [
  { value: 'TLS', label: 'TLS' },
  { value: 'SSL', label: 'SSL' },
  { value: 'NONE', label: 'Nesaugus ryšys' },
];

const SmtpTypeInput: FC<Props> = props => (
  <RadioGroup options={options} {...props} />
);

export default SmtpTypeInput;
